import React from "react";
import {
  calculateTotalAdditionalCost,
  calculateTotalCost,
} from "./fulfilmentCost";

/**
 * The fulfilment cost breakdown shown on hover, moved as-is from the Orders
 * Total column: weight or volume cost, pre-cost items, additional costs and
 * the total.
 */
const FulfilmentCostBreakdown = ({ row }) => (
  <div
    className="package__name_list_wrap fulfilment_cost_tooltip_content"
    style={{
      border: "1px solid var(--color-ui-border)",
      padding: "5px",
    }}
  >
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        marginBottom: "5px",
      }}
    >
      <strong className="fulfilmentcost__headers">Fulfilment Cost </strong>{" "}
    </div>
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        fontSize: "14px",
      }}
    >
      <label>
        <strong>
          {row?.formula?.["UnitType"] === "CBM" ? "Volume" : "Weight"}: (
          {row?.formula?.["TotalFulfilmentWeight"]} {row?.formula?.["UnitType"]}
          )
        </strong>
      </label>
      <span>
        <strong>{row?.formula?.["TotalWeightCost"]} CAD </strong>
      </span>
    </div>
    {row?.formula?.["TotalPreProduct"] > 0 && (
      <>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            fontSize: "14px",
          }}
        >
          <strong className="fulfilmentcost__headers">
            Pre Cost Item Quantity: ({row?.formula?.["TotalPreProduct"]})
          </strong>
          {/* <span>{row?.formula?.["TotalPreCost"]} CAD </span> */}
        </div>
        {/* {row?.order_details
                          ?.filter(
                            (singlelist) =>
                              singlelist?.products?.fulfillment_cost
                          )
                          .map((list, index) => (
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-between",
                                fontSize: "14px",
                              }}
                              key={index} // It's a good 5practice to provide a unique key for each mapped element
                            >
                              <label>
                                {list.product_name} ({list.item_quantity} x{" "}
                                {list.products?.fulfillment_cost})
                              </label>
                              <span>
                                {list.products?.fulfillment_cost *
                                  list.item_quantity}{" "}
                                CAD{" "}
                              </span>
                            </div>
                          ))} */}
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "end",
            fontSize: "14px",
          }}
        >
          <label>
            <strong>
              {/* Total: ({row?.formula?.["TotalPreProduct"]}) */}
            </strong>
          </label>
          <span>
            <strong>{row?.formula?.["TotalPreCost"]} CAD</strong>
          </span>
        </div>
      </>
    )}
    {row?.additional_costs?.length > 0 && (
      <>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            fontSize: "14px",
          }}
        >
          <strong className="fulfilmentcost__headers">
            Additional Cost: ({row?.additional_costs?.length})
          </strong>
          {/* <span>{row?.formula?.["TotalPreCost"]} CAD /span> */}
        </div>
        {row?.additional_costs?.map((list, index) => (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              fontSize: "14px",
            }}
            key={index} // It's a good 5practice to provide a unique key for each mapped element
          >
            <label>{list?.cost_type?.name}</label>
            <span>{list?.cost} CAD </span>
          </div>
        ))}
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "end",
            fontSize: "14px",
          }}
        >
          {/* <label>
    <strong>Total Items Fulfilment: ({row?.formula?.["TotalPreProduct"]})</strong>
    </label> */}
          <span>
            <strong
              style={{
                borderTop: "1px solid black",
              }}
            >
              {calculateTotalAdditionalCost(row)} CAD
            </strong>{" "}
          </span>
        </div>
        <hr />
      </>
    )}

    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        fontSize: "14px",
      }}
    >
      <label>
        <strong>Total Fulfilment COST: </strong>
      </label>
      <span>
        <strong>
          {/* {parseFloat(row?.formula?.["TotalFulfilmentCost"]) + */}
          {calculateTotalCost(row)} CAD{" "}
        </strong>
      </span>
    </div>
  </div>
);

export default FulfilmentCostBreakdown;
